import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/brand/logo-header.png" 
                alt="SIYAK"
                className="h-8 w-auto md:h-10"
              />
            </Link>
            <p className="text-navy-300 text-sm leading-relaxed">
              Property management tools for independent UK landlords.
            </p>
            <div className="text-navy-400 text-sm space-y-1">
              <p>Registered in England &amp; Wales</p>
              <p>Company No. 15140857</p>
              <p>ICO Registered: ZC111010</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-navy-300 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-navy-300 hover:text-white transition-colors text-sm">
                  Portal Access
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-navy-300 hover:text-white transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/mtd-guide" className="text-navy-300 hover:text-white transition-colors text-sm">
                  MTD Guide
                </Link>
              </li>
              <li>
                <Link to="/user-guide" className="text-navy-300 hover:text-white transition-colors text-sm">
                  User Guide
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-navy-300 hover:text-white transition-colors text-sm">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Support Us</h4>
            <p className="text-navy-300 text-sm leading-relaxed mb-4">
              Help us keep SIYAK independent.
            </p>
            <a 
              href="https://buymeacoffee.com/siyak" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-4 py-2 bg-royal-500 hover:bg-royal-600 text-white text-sm font-medium rounded-lg transition-colors"
            >
              Buy Me a Coffee
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-navy-700 text-center">
          <p className="text-navy-400 text-sm">
            © {new Date().getFullYear()} SIYAK Real Estate Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
